import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { SearchBar } from '~/components/HeaderV3/components/SearchBar';
import CartIcon from '~/components/MarketplaceIcons/CartIcon';
import SearchIcon from '~/components/MarketplaceIcons/SearchIcon';
import UserIcon from '~/components/MarketplaceIcons/UserIcon';
import { ModalType } from '~/components/Modal/interface';
import { useModal } from '~/hooks/useModal';
import { userStore } from '~/stores';

import { HEADER_ICON_CLASS } from './constants';
import { HeaderDubaiExpressCartButton } from './HeaderDubaiExpressCartButton';
import { HeaderDubaiExpressFavs } from './HeaderDubaiExpressFavs';

const ICON_SIZE_CLASS = 'size-[22px]';

/**
 * User actions of the DubaiExpress header (desktop): search, favorites with
 * their popover, profile and cart as 22px stroke glyphs that turn
 * brand-colored on hover.
 */
export const HeaderDubaiExpressNavigation = observer(() => {
  const { openModal } = useModal();

  const handleAuth = (e: React.MouseEvent) => {
    if (userStore.isAuthorized) {
      return;
    }
    e.preventDefault();
    openModal(ModalType.Auth, 'header', {
      redirect: '/cabinet',
    });
  };

  return (
    <>
      <SearchBar
        trigger={
          <div className={HEADER_ICON_CLASS}>
            <SearchIcon className={ICON_SIZE_CLASS} />
          </div>
        }
        fixedWidth={600}
      />
      <HeaderDubaiExpressFavs />
      <Link
        to="/cabinet"
        onClick={handleAuth}
        data-link="header-cabinet"
        className={HEADER_ICON_CLASS}
      >
        <UserIcon className={ICON_SIZE_CLASS} />
      </Link>
      <HeaderDubaiExpressCartButton>
        <CartIcon className={ICON_SIZE_CLASS} />
      </HeaderDubaiExpressCartButton>
    </>
  );
});
HeaderDubaiExpressNavigation.displayName = 'HeaderDubaiExpressNavigation';
